module.exports = __webpack_public_path__ + "img/wand.3083f5bd.png";